import React from 'react'
import { Link } from "react-router-dom";
import {
  // FormFooter,
  ModalAlert,
  Input,
  FormGroup,
  Button,
  StatusDot,
  ContentBlock,
  Card,
  Icon,
  Select,
  Head,
  Checkbox,
  Textarea,
  ImagePicker
} from "xsolla-uikit";


import PAh2 from "../PAh2";
// import { applyEasing } from '../sb/js/webflow';
export const PAcardInfo = ({
  card,
  handleClose = () => {
  void 0;
  },
  badgeText,
  title = "Title",
  description = "Short Description",
  descrLong = "Long Description",
  learnMoreUrl = '/',
  image,
  // image = "https://assets.website-files.com/5d303aa1e8832120171290c0/5d36ec9631adeb60604a357d_17698.jpg",
  icon = false, intTime = "less than 3 minutes", intStep0 = "", intStep1 = "", intStep2 = "", intStep3 = "", intStep4 = "", intStep5 = "" }) => {
  return (
    // <div className="p_fcard0 shown">
    //   <div
    //     className="p_fcard_z"
    //     onClick={() => {
    //       handleClose();
    //     }}
    //   />
    <div className="p_fcard" style={{fontSize: 14}}>
      <div className="p_content-block p_content-block--lp">
        <div className="p_fcard_c0">
          <div className="p_fcard_c">
            <div className="p_fcard_c_grid" style={{display: 'grid', gridTemplateColumns: '2fr 1.5fr'}}>


              <div className="p_fcard_c_grid--1">
                <div className="p_x_card_z" />

                {card['badgeText'] && (<div className="p_spacer_badge0">
                  <div className="p_spacer_badge0">
                    <div className="p_spacer_badge" />
                  </div>
                  <div className="p_spacer_badge0">
                    <div className="p_spacer_badge" />
                  </div>
                </div>)}

                {card['badgeText'] && (<div className="p_img_badge0">
                  <div className="p_modal_badge p_modal_badge--sm">
                    <div>{card['badgeText']}</div>
                  </div>
                </div>)}

                <div className="p_head_pic0 p_head_pic0--modal">
                  <div className="p_img_placeholder">
                    <div className="p_icon w-condition-invisible w-embed">
                      <svg width={120} height={120} viewBox="0 0 48 48">
                        <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={2}>
                          <path d="M29 29V8l-4-7h-2l-4 7v21zm-10-6h-3l-3 3v7h2l4-4zm10 0h3l3 3v7h-2l-4-4zm-9 13v2m0 2v2m8-6v2m0 2v2m-4-2v2m6-8v2m0 2v2m-12-6v2m0 2v2" />
                          <path strokeLinecap="round" d="M7.778 42.222a3.111 3.111 0 0 1 6.222 0M7 36a3.111 3.111 0 0 1 3.111 3.111" />
                          <path d="M24 36v2m0-6v2m-4-2v2m8-2v2m-6-9h4m-2-7v-2m0-2v-2m0-2V8M1 43v2l2 2h42l2-2v-2z" />
                          <path strokeLinecap="round" d="M44 43V17a2 2 0 0 0-2-2H32M4 43V17a2 2 0 0 1 2-2h10m24.222 27.222a3.111 3.111 0 0 0-6.222 0M41 36a3.111 3.111 0 0 0-3.111 3.111" />
                        </g>
                      </svg>
                    </div>
                    <div className="p_icon w-condition-invisible w-embed">
                      <svg width={120} height={120} viewBox="0 0 43 42">
                        <path fill="currentColor" fillRule="nonzero" d="M28.375 34.655a1 1 0 0 1 .374.416l1.751 3.628 1.751-3.628a1 1 0 0 1 .374-.416l3.477-2.155-3.477-2.155a1 1 0 0 1-.374-.416L30.5 26.301l-1.751 3.628a1 1 0 0 1-.374.416L24.898 32.5l3.477 2.155zM16 23.874A4.002 4.002 0 0 1 13 20a1 1 0 0 1 2 0 2 2 0 1 0 2-2 4 4 0 0 1-1-7.874V9a1 1 0 0 1 2 0v1.126c1.725.444 3 2.01 3 3.874a1 1 0 0 1-2 0 2 2 0 1 0-2 2 4 4 0 0 1 1 7.874V25a1 1 0 0 1-2 0v-1.126zm6.473 9.476a1 1 0 0 1 0-1.7l4.601-2.852 2.525-5.233a1 1 0 0 1 1.802 0l2.525 5.233 4.6 2.852a1 1 0 0 1 0 1.7l-4.6 2.852-2.525 5.233a1 1 0 0 1-1.802 0l-2.525-5.233-4.6-2.852zm8.015-15.491a1 1 0 0 1 0-1.718l3.304-1.971 1.814-3.618a1 1 0 0 1 1.788 0l1.814 3.618 3.304 1.971a1 1 0 0 1 0 1.718l-3.304 1.971-1.814 3.618a1 1 0 0 1-1.788 0l-1.814-3.618-3.304-1.971zm4.58.404a1 1 0 0 1 .381.41L36.5 20.77l1.05-2.096a1 1 0 0 1 .382-.41L40.048 17l-2.116-1.263a1 1 0 0 1-.381-.41L36.5 13.23l-1.05 2.096a1 1 0 0 1-.382.41L32.952 17l2.116 1.263zm-15.465 13.53a1 1 0 1 1 .327 1.974C11.107 35.227 2.637 29.692.5 21.063c-2.14-8.632 2.78-17.441 11.28-20.212 8.5-2.77 17.714 1.427 21.144 9.634a1 1 0 0 1-1.846.771C28.05 4.012 19.91.304 12.4 2.752 4.893 5.2.554 12.97 2.44 20.582c1.887 7.614 9.367 12.502 17.163 11.212zm6.247-8.767a1 1 0 0 1 1.682 1.082c-3.266 5.074-9.555 7.186-15.16 5.086-5.598-2.097-9.024-7.84-8.268-13.843.757-6.006 5.5-10.69 11.442-11.287 5.944-.598 11.502 3.053 13.403 8.795a1 1 0 0 1-1.898.629C25.443 8.63 20.753 5.55 15.746 6.054c-5.01.503-9.017 4.46-9.658 9.547-.64 5.089 2.26 9.95 6.986 11.72 4.72 1.77 10.018-.01 12.776-4.295z" />
                      </svg>
                    </div>
                    <div className="p_spacer_image w-condition-invisible" />
                  </div>
                  <div style={{ backgroundImage: `url(${card['image']})` }} className="p_img w-condition-invisible" />
                </div>
                <div className="p_modal_c p_head">
                  <div className="p_head_b p_head_b--border-0">
                    <PAh2 tag="h1" title={card['title']} />
                  </div>
                </div>
                <div className="p_x_grow">
                  <div className="p_formgroup_md">
                    <div className="p_modal_c">
                      <div className="p_x_descr w-richtext">
                        <p>{card['description']}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p_formgroup_lg">
                    <div className="p_modal_c">
                      <div className="w-richtext">
                        <p>{card['descrLong']}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div className="p_fcard_c_grid--2"
                style={{minWidth: 'none'}}
              >
                <div className="p_modal_c p_modal_c--bot">
                  <div className="p_formgroup_lg p_formgroup_--todo">
                    <div className="p_modal_c p_todo_item">
                      <div className="x_flex">
                        How to:
                        <div className="p_int_time0">
                          less than 3 minutes
                        </div>
                      </div>
                    </div>


                    {card['steps'] && card['steps'].map((oneStep, index) => {
                      return (
                        <div className="p_modal_c p_todo_item" key={`step_${index}`}>
                          <div className="x_flex">
                            <div className="p_modal_todo_icon">
                              {oneStep['progress'] === 1 && <img src="https://assets.website-files.com/5d2d1e42b1d78992ec4bcf44/5d3030ef8e44eb3c33b14a09_on.svg" />}
                              {oneStep['progress'] === 0 && <img src="https://assets.website-files.com/5d2d1e42b1d78992ec4bcf44/5d30313174677aa03c1d645c_OFF.svg" />}
                            </div>
                            {/* <div className="p_modal_todo_name p_modal_todo_name--done"> */}
                              {oneStep['step']}
                            {/* </div> */}
                        </div>
                      </div>
                      )
                    })}





                    <div className="p_modal_c p_todo_item">
                      <div className="x_flex">
                        <div className="p_modal_todo_icon">

                        </div>
                        <div className="p_modal_todo_name">{intStep1}</div>
                      </div>
                    </div>


                </div>
                <div className="p_formfooter p_formfooter--dash">
                  <div className="p_formgroup_sm">
                    <div className="p_modal_c">
                      <div className="p_formgroup_xs">
                        <div className="p_comp_int-ctas">
                          <div className="x_flex x_flex--space x_flex--4center">
                            <div className="p_x_start">



                      <div className="l_flex">
                        <Link to={learnMoreUrl} className="p_button p_button--sm">
                          <div>Use now</div>
                        </Link>

                        &nbsp;&nbsp;&nbsp;&nbsp;


                        <Button appearance="flatten" size="sm" onClick={() => {
                        }}>
                          <div>Assign to...</div>
                        </Button>

                      </div>



                            </div>

                            <div>
                              <div className="p_x_delegate">


                                <div data-w-id="2cabdda3-fd8e-73ad-7b11-eda8751f7280" className="p_x_assign0 shown">
                                  <div className="p_x_assign">
                                    <div className="p_x_assign_li">
                                      <div className="p_0_x_menu-sett p_0_x_menu-sett--big">
                                        <div className="p_button_icon p_0_x_menu-sett--big">
                                          <div className="p_xsollaicon p_xsollaicon--sm">
                                            <div></div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="p_0_x_menu-sett">
                                        Contact account manager
                                        </div>
                                    </div>
                                    <div className="p_x_assign_li">
                                      <div className="p_0_x_menu-sett">
                                        <div className="p_button_icon p_0_x_menu-sett--big">
                                          <div className="p_xsollaicon p_xsollaicon--sm">
                                            <div></div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="p_0_x_menu-sett">
                                        Assign to co-worker
                                        </div>
                                    </div>
                                    <div className="p_x_assign_li p_x_assign_li--2nd">
                                      <div className="p_x_emailinput w-embed">
                                        <input className="p_x_emailinput" placeholder="name@yourcompany.com" defaultValue />
                                      </div>
                                    </div>
                                  </div>
                                </div>



                              </div>
                              <div className="p_button p_button--appearance-right">
                                <div>Later</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};
